// ¿Está React hidratando HTML prerenderizado? (LDT-718)
//
// Al hidratar, el primer render del cliente tiene que producir EXACTAMENTE el
// HTML que escribió el prerender (en Node, sin localStorage ni window). Lo que
// se lea del navegador en ese primer render —el consentimiento de cookies
// guardado, por ejemplo— tiene que empezar con el valor del prerender y
// corregirse en un efecto. Fuera de la hidratación (app.html, 404.html, tests)
// se sigue leyendo al momento, como siempre.
//
// Lo marca src/main.tsx justo antes de hydrateRoot. No se desmarca: solo lo
// consulta el estado inicial de los componentes que se montan al arrancar.

let hydratingPrerender = false;

export function markHydratingPrerender(): void {
  hydratingPrerender = true;
}

export function isHydratingPrerender(): boolean {
  return hydratingPrerender;
}
